<template>
  <page-view :title="false">
    <a-card :bordered="false" v-show="!showIframe">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="合同模板ID"
                ><a-input
                  v-model="queryParam.templateId"
                  placeholder="合同模板ID"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="商户名称"
                ><a-input
                  v-model="queryParam.merchantName"
                  placeholder="商户名称"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="商户类型">
                  <a-select
                    v-model="queryParam.merchantType"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="1">公司</a-select-option>
                    <a-select-option value="2">个人</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <!-- <a-button
                  type="primary"
                  icon="plus"
                  @click="add"
                  v-hasAnyPermission="`contracttemplate:add`"
                  class="button-margin-left"
                  >新建</a-button
                > -->
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1760 }"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              v-if="record.isDefault == 'T'"
              color="#108ee9"
              >默认</a-tag
            >
          </template>
        </span>

        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`contracttemplate:edit`"
              >编辑</a
            >
            <a
              class="a-action"
              @click="action(record, 'editTemplate')"
              v-hasAnyPermission="`contracttemplate:template`"
              >模板</a
            >
            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`contracttemplate:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <a-card :bordered="false" v-if="showIframe">
      <div class="table-page-search-wrapper">
        <div style="text-align: right;">
          <a-button @click="back" class="button-margin-left">返回</a-button>
        </div>
      </div>
    </a-card>

    <contract-template-info
      ref="info"
      @success="$refs.table.refresh(true)"
    ></contract-template-info>

    <!-- iframe 合同自定义 -->
    <div style="height: 100%;width: 100%;" v-if="showIframe">
      <iframe
        :src="url"
        hight="100%"
        ref="frame"
        width="100%"
        frameborder="0"
        scrolling="auto"
      ></iframe>
    </div>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import ContractTemplateInfo from "./ContractTemplateInfo.vue";

export default {
  name: "ContractTemplateList",
  components: {
    PageView,
    STable,
    ContractTemplateInfo
  },
  data() {
    return {
      showIframe: false,
      url: "",
      userInfo: {},
      // 高级搜索 展开/关闭
      advanced: false,
      provinceList: [],
      cityList: [],
      tmpCityList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "商户编号",
          dataIndex: "merchantNo",
          fixed: "left"
        },
        {
          title: "商户名称",
          dataIndex: "merchantName",
          fixed: "left"
        },
        {
          title: "合同模板id",
          dataIndex: "templateId",
          scopedSlots: { customRender: "tagItem" },
          width: 240,
          fixed: "left"
        },
        {
          title: "模板标题",
          dataIndex: "templateTitle",
          ellipsis: true,
          width: 300
        },
        {
          title: "模板描述",
          dataIndex: "description",
          ellipsis: true,
          width: 600
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          ellipsis: true,
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageMerchantContractTemplate(
            Object.assign(parameter, this.queryParam)
          )
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  watch: {
    showIframe(v) {
      if (v) {
        this.getFrame();
      }
    }
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  mounted() {
    window.addEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      this.showIframe = false;
      this.url = "";
      this.$router.push({
        name: "ContractTemplateList"
      });
    },
    getFrame() {
      this.$nextTick(() => {
        const iframe = this.$refs.frame;
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", function() {
            iframe.height = 1000;
          });
        } else {
          iframe.onload = function() {
            iframe.height = 1000;
          };
        }
      });
    },

    action(record, type) {
      if (type == "edit") {
        this.$refs.info.showModal(type, record);
      } else if (type == "del") {
        this.$http.roomBksApi
          .removeMerchantContractTemplate({
            merchantNo: record.merchantNo,
            templateId: record.templateId
          })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      } else if (type == "editTemplate") {
        let param = {};
        param.account = record.merchantNo;
        param.userType = "M";
        param.templateId = record.templateId;
        this.$http.roomBksApi.getModifyTempatePageUrl(param).then(res => {
          if (res.result == 0) {
            this.showIframe = true;
            this.url = res.resultObject;
          }
        });
      }
    },
    add() {
      let param = {};
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    back() {
      this.showIframe = false;
      this.url = "";
      this.$refs.table.refresh(true);
    }
  }
};
</script>
<style lang="less">
.sign-elems {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .elem {
    padding: 3px 5px;
    font-size: 14px;
    border: 1px solid grey;
    border-radius: 5px;
    margin: 5px;
  }
}
</style>
